import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ENDPOINTS } from '@shared/constants';
import {
  CommonResponseDTO,
  IApiKey,
  IPublicKeyResponse,
} from '@shared/interfaces';
import { EndpointData, generateURL } from '@shared/utils';

@Injectable({
  providedIn: 'root',
})
export class ProposalKeysService {
  constructor(private http: HttpClient) {}

  saveGeneratedPublicApiKey(
    apiKey: string,
    reference: string
  ): Observable<CommonResponseDTO<IPublicKeyResponse>> {
    const url = generateURL({
      endpoint: ENDPOINTS.PROPOSAL_SAVE_GENERATED_API_KEY,
    });
    return this.http.post<CommonResponseDTO<IPublicKeyResponse>>(url, {
      apiKey,
      reference,
    });
  }

  getDocumentation(): Observable<CommonResponseDTO<EndpointData[]>> {
    // for public api
    const url = generateURL({
      endpoint: ENDPOINTS.PROPOSAL_GET_ALL_DOCUMENTATIONS,
    });

    return this.http.get<CommonResponseDTO<EndpointData[]>>(url);
  }

  getGeneratedKeys(): Observable<CommonResponseDTO<IApiKey[]>> {
    const url = generateURL({
      endpoint: ENDPOINTS.PROPOSAL_GET_ALL_GENERATED_KEYS,
    });
    return this.http.get<CommonResponseDTO<IApiKey[]>>(url);
  }

  generatePublicApiKey(): Observable<CommonResponseDTO<IPublicKeyResponse>> {
    const url = generateURL({
      endpoint: ENDPOINTS.PROPOSAL_GENERATE_PUBLIC_API_KEY,
    });
    return this.http.get<CommonResponseDTO<IPublicKeyResponse>>(url);
  }

  deleteKey(id: string): Observable<CommonResponseDTO<IApiKey>> {
    const url = generateURL({
      endpoint: ENDPOINTS.PROPOSAL_DELETE_KEY,
      params: { id },
    });
    return this.http.delete<CommonResponseDTO<IApiKey>>(url);
  }

  restoreKey(id: string): Observable<CommonResponseDTO<IApiKey>> {
    const url = generateURL({
      endpoint: ENDPOINTS.PROPOSAL_RESTORE_KEY,
      params: { id },
    });
    return this.http.patch<CommonResponseDTO<IApiKey>>(url, {});
  }

  getGeneratedKey(
    id: string
  ): Observable<CommonResponseDTO<IPublicKeyResponse>> {
    const url = generateURL({
      endpoint: ENDPOINTS.PROPOSAL_GET_SPECIFIC_GENERATED_KEY,
      params: { id },
    });
    return this.http.get<CommonResponseDTO<IPublicKeyResponse>>(url);
  }
}
